export const formatCountdown = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const toMinutes = (ms: number, precision = 1): number => {
  if (!Number.isFinite(ms) || ms <= 0) {
    return 0;
  }
  const minutes = ms / 60000;
  const factor = 10 ** precision;
  return Math.round(minutes * factor) / factor;
};

export const toMilliseconds = (minutes: number): number => {
  if (!Number.isFinite(minutes) || minutes <= 0) {
    return 0;
  }
  return Math.round(minutes * 60000);
};
